export default __webpack_public_path__ + "static/media/patrick-tomasso.d5f38984.jpg";